import { Component } from '@angular/core';
import { ThemeOptions } from '../../theme-options';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './sidebar-header.component.html'
})
export class SidebarHeaderComponent {
  currentUserName;
  isStationManager = false;
  constructor(public globals: ThemeOptions, private authenticationService: AuthenticationService) { }
  toggleSidebarCollapse() {
    this.globals.toggleSidebar = !this.globals.toggleSidebar;

  }
  toggleSidebarMobileOpen() {
    this.globals.toggleSidebarMobile = !this.globals.toggleSidebarMobile;
    this.globals.toggleSidebar = false;
  }
}
